import { render, staticRenderFns } from "./Linkage.vue?vue&type=template&id=c3e1e476&scoped=true"
import script from "./Linkage.vue?vue&type=script&lang=js"
export * from "./Linkage.vue?vue&type=script&lang=js"
import style0 from "./Linkage.vue?vue&type=style&index=0&id=c3e1e476&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e1e476",
  null
  
)

export default component.exports